export default __webpack_public_path__ + "static/media/pointer-up.0f6511ad.svg";